module.exports = __webpack_public_path__ + "img/locandina.45f461c6.jpg";